import { Form } from 'antd';
import React, { useCallback, useEffect, useReducer, useRef } from 'react'
import { checkQuotation, createComments, editComment, getCommentAndTags, getDataFormByKey, requestDeleteComment, sendeEmailComment, setJsonBySave } from '../helpers/formCommentsHelpers';
import { typeForDetailsProyect } from '../../../../types/typeModalDetailsProject';
import { ContainerModal } from '../../../../components/container/ContainerModal';
import { ButtonsFormComments } from '../components/ButtonsFormComments';
import { WrapperLoadinModal } from '../components/WrapperLoadinModal';
import { FormConcluedContext } from '../context/FormConcluedContext';
import { TabOption } from '../components/TabOption';
import { useFormFieldsManager } from '../hooks/useFormFieldsManager';

const headerIteam = ["Análisis", "Comentarios", "Cotización"];

export const initialStateFormConclued = {
    modalState: {
        isLoadingModal: true,
        errorModal: false,
        loading: false,
        selectIteamTab: 0,
        optionRadio: true,
    },
    dataConclued: {
        analysis: [],
        comments: [],
        quotation: [],
        tableData: [],
        isEditForm: false,
        isOvertimeComments: false
    }
};

const formConcluedReducer = (state, action) => {
    switch (action.type) {
        case 'SET_MODAL_STATE':
            return {
                ...state,
                modalState: { ...state.modalState, [action.key]: action.value }
            };
        case 'SET_DATA_CONCLUED':
            return {
                ...state,
                dataConclued: { ...state.dataConclued, ...action.payload }
            };
        case 'RESET_MODAL':
            return initialStateFormConclued;
        default:
            return state;
    }
};

export const FormConcluedProvider = ({
    children,
    closeModalDetails,
    activeModalDetailsProject,
    project,
    auth,
    updateProject,
    disableIputs,
}) => {
    const [form] = Form.useForm();
    const commentByTabRef = useRef({});
    const idUpdateComment = useRef(null);

    const {
        fieldStates: checkAll,
        updateFieldStatesByForm: updateRefChecked,
        updateFieldState: onChangueSelectAll
    } = useFormFieldsManager();

    const {
        fieldStates: buttonsCheked,
        updateFieldStatesByForm: updateButtonsByForm,
        updateFieldState: updateButtons
    } = useFormFieldsManager();

    const [state, dispatch] = useReducer(formConcluedReducer, initialStateFormConclued);

    const updateModalState = (key, value) => {
        dispatch({ type: 'SET_MODAL_STATE', key, value });
    };

    const handleCommentUpdate = async ({ idChild = 0, isEdit = false }) => {
        if (!isEdit) idUpdateComment.current = idChild;

        if (disableIputs || !state.dataConclued.isEditForm || !isEdit || idChild === -1) return true;
        if (state.modalState.loading) return false;

        try {
            updateModalState('loading', true);
            await form.validateFields();

            const wasUpdateSuccessful = await editComment({ project, idChild, auth, form })

            idUpdateComment.current = null;

            return wasUpdateSuccessful;
        } catch (error) {
            console.log("no se relleno");
            return false;
        } finally {
            updateModalState('loading', false);
        }
    };

    const handleCommentDeletion = async ({ idChild = 0 }) => {
        const { key, data } = getDataFormByKey(form);

        if (disableIputs) return false;

        if (!getDataFormByKey(form).data[idChild]?._id && key === "cotizacion") {
            updateModalState('optionRadio', true);
            return true
        }

        if (!state.dataConclued.isEditForm || !getDataFormByKey(form).data[idChild]?._id) return true;

        try {

            const { _id = null } = data[idChild];
            updateModalState('optionRadio', data.length === 1);
            updateModalState('loading', true);
            const isdelete = await requestDeleteComment(_id);
            return isdelete;
        } catch (error) {
            console.log("no se elimino", error);
            return false;
        } finally {
            updateModalState('loading', false);
        }
    };

    const submitFinalComment = async () => {
        if (disableIputs) return false;

        updateModalState('loading', true);

        const { wasUpdateSuccessful, clickupSpace } = await createComments({
            project,
            auth,
            commentByTabRef: commentByTabRef.current,
            isEditForm: state.dataConclued.isEditForm
        });

        if (wasUpdateSuccessful) {
            await updateProject(clickupSpace);
            closeModalDetails();
        }
        updateModalState('loading', false);
        return true
    };

    const processEditForm = async (data) => {

        const idUpdateIndex = idUpdateComment.current === null
            ? data.findIndex((d) => !d._id)
            : idUpdateComment.current;

        const isUpdateByNext = await handleCommentUpdate({ idChild: idUpdateIndex, isEdit: true });

        if (!isUpdateByNext) return false;

        return true
    }

    const handleFormAction = async ({ data, key }) => {
        if (state.dataConclued.isEditForm) {
            return await processEditForm(data)
        }

        const formJson = setJsonBySave({ category: key, subCategorys: data });
        commentByTabRef.current[key] = formJson;
        if (state.modalState.selectIteamTab === headerIteam.length - 1) {
            return await submitFinalComment();
        }

        return true
    }

    const nextTab = async () => {
        try {
            await form.validateFields();
            const { key, data } = getDataFormByKey(form);
            const isNextTab = await handleFormAction({ data, key })
            if (!isNextTab) return

            if (state.modalState.selectIteamTab === headerIteam.length - 1) {
                updateModalState('loading', true);
                await sendeEmailComment({ project })
                updateModalState('loading', false);
                return
            };

            updateModalState('selectIteamTab', state.modalState.selectIteamTab + 1);
        } catch (error) {
            console.log('Falta inputs sin rellenar');
        }
    };

    const backTab = () => {
        if (state.modalState.selectIteamTab === 0) return;
        updateModalState('selectIteamTab', state.modalState.selectIteamTab - 1);
    };

    const updateQuatition = (value) => {
        if (disableIputs) return;

        const { key, data } = getDataFormByKey(form);
        if (data.length > 0) {
            const { ok, code } = checkQuotation(data)
            if (!ok) return
            if (code === 0) {
                form.setFieldsValue({ [key]: [] });
            }
        }
        updateModalState('optionRadio', value);
    };

    const getData = useCallback(async () => {
        updateModalState('isLoadingModal', true);
        updateModalState('errorModal', false);

        const { clickupSpace, calculatedHours, overtimecomments = [] } = project;
        const data = await getCommentAndTags(clickupSpace, calculatedHours.total);

        if (!data) {
            updateModalState('errorModal', true);
            return;
        }

        const { dataTable, formsData } = data;
        form.setFieldsValue(formsData);

        dispatch({ type: 'SET_DATA_CONCLUED', payload: { ...dataTable, isOvertimeComments: overtimecomments.length > 0 } });

        updateModalState('optionRadio', !(formsData["cotizacion"].length > 0));
        updateModalState('isLoadingModal', false);
    }, [form, project]);

    useEffect(() => {
        getData();
    }, [getData]);

    const value = {
        form,
        dataConcluded: state.dataConclued,
        optionRadio: state.modalState.optionRadio,
        selectedTab: state.modalState.selectIteamTab,
        updateQuatition,
        actionsComments: {
            updateComment: handleCommentUpdate,
            deleteComment: handleCommentDeletion,
        },
        fieldCheck: {
            checkAll,
            updateRefChecked,
            onChangueSelectAll
        },
        fieldButton: {
            buttonsCheked,
            updateButtonsByForm,
            updateButtons
        },
    };

    return (
        <FormConcluedContext.Provider value={value}>
            <div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
                <ContainerModal
                    title={"Concluido"}
                    actionButton={() => {
                        closeModalDetails();
                    }}
                    className={"w-[350px] md:w-[392px] max-h-screen"}
                >
                    <Form form={form} className="w-full h-full ">
                        <TabOption tabs={headerIteam} selectIteam={state.modalState.selectIteamTab} />
                        <WrapperLoadinModal error={state.modalState.errorModal} loading={state.modalState.isLoadingModal} >
                            {children}
                            <ButtonsFormComments
                                isOvertimeComments={state.dataConclued.isOvertimeComments}
                                actionOverTime={() => {
                                    activeModalDetailsProject(typeForDetailsProyect.projectRed, { disabled: true })
                                }}
                                loading={state.modalState.loading}
                                selectIteamTab={state.modalState.selectIteamTab === 0}
                                backTab={backTab}
                                nextTab={nextTab}
                                isDisableBackButton={!buttonsCheked.every(value => value === true)}
                            >
                                {state.modalState.selectIteamTab === headerIteam.length - 1 ? 'Enviar Email' : 'Siguiente'}
                            </ButtonsFormComments>
                        </WrapperLoadinModal>
                    </Form>
                </ContainerModal>
            </div>
        </FormConcluedContext.Provider>
    );
};
